import type { ReactNode } from 'react'
import { ICON_SIZE, ICON_STROKE, type LucideIcon } from '@/components/icons'

/** "There is genuinely nothing here yet." */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: {
  icon: LucideIcon
  title: string
  /** Say what WOULD create one. "No leads yet" alone leaves the reader unsure */
  description: string
  action?: ReactNode
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-16 text-center">
      <Icon size={ICON_SIZE.lg} strokeWidth={ICON_STROKE} aria-hidden className="text-subtle" />
      <p className="text-h3 font-semibold text-text">{title}</p>
      <p className="max-w-sm text-sm text-muted">{description}</p>
      {action && <div className="mt-2">{action}</div>}
    </div>
  )
}
